import actions from './actions';
import { createReducer } from '../../helpers/reducer';
import { IOrgSwitcherState, IUserOrgsData } from './types';

const initState: IOrgSwitcherState = {
  loading: false,
  error: null,
  data: null,
};

function onFetchUserOrgsRequest(state: IOrgSwitcherState) {
  return { ...state, loading: true, error: null };
}

function onFetchUserOrgsSuccess(state: IOrgSwitcherState, { payload }: { payload: IUserOrgsData }) {
  return {
    ...state,
    loading: false,
    data: payload,
  };
}

function onFetchUserOrgsError(state: IOrgSwitcherState, { payload }: { payload: string }) {
  return { ...state, loading: false, error: payload };
}

export default createReducer(initState, {
  [actions.FETCH_USER_ORGS_REQUEST]: onFetchUserOrgsRequest,
  [actions.FETCH_USER_ORGS_SUCCESS]: onFetchUserOrgsSuccess,
  [actions.FETCH_USER_ORGS_ERROR]: onFetchUserOrgsError,
});
